import type React from 'react';

import { CanonicalUrlContainer } from './CanonicalUrl';
import { MetaContainer } from './Meta';
import { TitleContainer } from './Title';

export const HeadContainer: React.FC = () => {
	return (
		<>
			<TitleContainer />
			<CanonicalUrlContainer />
			<MetaContainer />
		</>
	);
};
